"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var collectionsRef_1 = require("common/db/collectionsRef");
var app_1 = __importDefault(require("firebase/app"));
function createEmptyRFQ(IRData) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var irItemsSN, IRItemsData, doc;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, collectionsRef_1.IRItemsRef.where("IRId", "==", IRData.id).get()];
                case 1:
                    irItemsSN = _b.sent();
                    IRItemsData = irItemsSN.docs.map(function (d) { return (__assign(__assign({}, d.data()), { id: d.id })); });
                    return [4 /*yield*/, collectionsRef_1.RFQsRef.add({
                            orderId: IRData.orderId,
                            status: "draft",
                            projectId: IRData.projectId,
                            projectsIds: IRData.projectsIds,
                            createdAt: new Date(),
                            initiatedBy: app_1.default.auth().currentUser.uid,
                            officeId: IRData.officeId,
                            RFQNo: IRData.ref,
                            irId: IRData.id,
                            exchangeRate: IRData.exchangeRate,
                            formDescription: " \nIndependent Doctors Association\nBinevler Mahallesi \n81053 Nolu Sokak No:34 \n\u015Eahinbey,Gaziantep\t\t\t\nTurkey \t\t\t\t\nTel: +90 534 078 50 40\nEmail: elif.sahin@ida-org.com",
                            budgetLineId: (_a = IRData.budgetLineId) !== null && _a !== void 0 ? _a : "",
                        })];
                case 2:
                    doc = _b.sent();
                    return [4 /*yield*/, Promise.all(IRItemsData.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                            var itemDescription;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, collectionsRef_1.productsRef.doc(item.productId).get()];
                                    case 1:
                                        itemDescription = (_a = (_b.sent()).data().description) !== null && _a !== void 0 ? _a : "";
                                        return [4 /*yield*/, collectionsRef_1.RFQItemsRef.add({
                                                IRItemId: item.id,
                                                RFQId: doc.id,
                                                orderId: IRData.orderId,
                                                unitPrice: 0,
                                                quantity: item.quantity,
                                                total: 0,
                                                productId: item.productId,
                                                productType: item.productType,
                                                productName: item.productName,
                                                budgetLineId: item.budgetLineId,
                                                budgetLinesIds: item.budgetLinesIds,
                                                budgetLinesPercentages: item.budgetLinesPercentages,
                                                unitId: item.unitId,
                                                index: item.index,
                                                itemDescription: itemDescription,
                                                createdAt: new Date(),
                                            })];
                                    case 2: return [2 /*return*/, _b.sent()];
                                }
                            });
                        }); }))];
                case 3:
                    _b.sent();
                    return [2 /*return*/, doc.id];
            }
        });
    });
}
exports.default = createEmptyRFQ;
